import React from "react";
import { string, bool } from "prop-types";

import "./sub-section-heading.m.css";

const SubSectionHeading = ({ children, variant = "light", ...props }) => {
  const styleClass = variant === "dark" ? "sub-section-heading-dark" : "sub-section-heading";

  return (
    <h3 styleName={styleClass} {...props}>
      {children}
    </h3>
  );
};

SubSectionHeading.propTypes = {
  children: string.isRequired,
  variant: string
};

export default SubSectionHeading;